"use client";

export function EqualizerIcon({ className }: { className?: string }) {
  return (
    <div className={`flex items-end gap-[2px] h-[18px] ${className ?? ""}`}>
      <span className="w-[3px] rounded-full bg-current animate-equalizer-1" />
      <span className="w-[3px] rounded-full bg-current animate-equalizer-2" />
      <span className="w-[3px] rounded-full bg-current animate-equalizer-3" />
      <span className="w-[3px] rounded-full bg-current animate-equalizer-4" />
    </div>
  );
}
